export * from './Resultado.nav';